<template>
  <Modal v-if="autoescola" ref="modal" :title="autoescola.nome_fantasia" @cancel="close">
    <div class="modal-container">
      <div class="bloco input-row">
        <Input class="input-full" legend="Vendedor"
          :modelValue="autoescola.vendedor_atribuido ? autoescola.vendedor_atribuido.vendedor.nome : 'Sem vendedor atribuído'"
          :readonly="true" />
        <Input class="input-full" legend="Data da atribuição"
          :modelValue="autoescola.vendedor_atribuido ? utils.formatOnlyDate(autoescola.vendedor_atribuido.inicio) : 'Sem vendedor atribuído'"
          :readonly="true" />
      </div>

      <form @submit.prevent="handleSubmitVendedor" class="bloco">
        <div class="input-row">
          <SingleDate class="input-full" legend="Início do atendimento" :modelValue="inicioAtendimento"
            @update:modelValue="$event => (this.inicioAtendimento = $event)" />

          <Select class="input-full" :options="vendedores" legend="Vendedor" placeholder="Selecione o vendedor"
            :modelValue="seller" @update:modelValue="$event => (this.seller = $event)" :disabled="loading" />

          <Button text="Atualizar vendedor" color="primary">
            <Refresh :size="18" />
          </Button>
        </div>
      </form>

      <form @submit.prevent="handleUpdateGratuidade" class="bloco">
        <div class="input-container">
          <div class="input-row">
            <SingleDate class="input-full" legend="Início da gratuidade (Teórica)"
              :modelValue="gratuidade.teoricaInicio"
              @update:modelValue="$event => (this.gratuidade.teoricaInicio = $event)"
              :disabled="gratuidade.gratuidadeTeorica" />

            <SingleDate class="input-full" legend="Fim da gratuidade (Teórica)" :modelValue="gratuidade.teoricaFim"
              @update:modelValue="$event => (this.gratuidade.teoricaFim = $event)"
              :disabled="gratuidade.gratuidadeTeorica" />

            <div class="checkbox">
              <label>
                <input type="checkbox" v-model="gratuidade.gratuidadeTeorica" @change="disabledTheoreticalGratuity" />
                <span class="input"></span>
                <span class="text">
                  Cadastrar serviço teórico sem gratuidade
                </span>
              </label>
            </div>
          </div>

          <div class="input-row">
            <SingleDate class="input-full" legend="Início da gratuidade (Prática carro)"
              :modelValue="gratuidade.carroInicio" @update:modelValue="$event => (this.gratuidade.carroInicio = $event)"
              :disabled="gratuidade.gratuidadeCarro" />

            <SingleDate class="input-full" legend="Fim da gratuidade (Prática carro)" :modelValue="gratuidade.carroFim"
              @update:modelValue="$event => (this.gratuidade.carroFim = $event)"
              :disabled="gratuidade.gratuidadeCarro" />

            <div class="checkbox">
              <label>
                <input type="checkbox" v-model="gratuidade.gratuidadeCarro" @change="disabledCarGratuity" />
                <span class="input"></span>
                <span class="text">
                  Cadastrar serviço prático de carro sem gratuidade
                </span>
              </label>
            </div>
          </div>

          <div class="input-row">
            <SingleDate class="input-full" legend="Início da gratuidade (Prática moto)"
              :modelValue="gratuidade.motoInicio" @update:modelValue="$event => (this.gratuidade.motoInicio = $event)"
              :disabled="gratuidade.gratuidadeMoto" />

            <SingleDate class="input-full" legend="Fim da gratuidade (Prática moto)" :modelValue="gratuidade.motoFim"
              @update:modelValue="$event => (this.gratuidade.motoFim = $event)" :disabled="gratuidade.gratuidadeMoto" />

            <div class="checkbox">
              <label>
                <input type="checkbox" v-model="gratuidade.gratuidadeMoto" @change="disabledMotocycleGratuity" />
                <span class="input"></span>
                <span class="text">
                  Cadastrar serviço prático de moto sem gratuidade
                </span>
              </label>
            </div>
          </div>

          <Button class="full-button" type="submit" text="Confirmar" color="primary" />
        </div>
      </form>
    </div>
  </Modal>
</template>

<script>
import utils from '../../services/utils'
import Modal from 'core/Modal'
import Input from 'core/Input'
import Select from 'core/Select'
import SingleDate from 'core/SingleDate'
import Button from 'core/Button'
import Refresh from 'icons/Refresh'

export default {
  name: 'VendedoresModal',
  components: {
    Modal,
    Input,
    Select,
    SingleDate,
    Button,

    Refresh,
  },
  props: {
    vendedores: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      utils: utils,
      seller: '',
      inicioAtendimento: '',
      autoescola: null,
      details: {},
      gratuidade: {
        teoricaInicio: '',
        teoricaFim: '',
        carroInicio: '',
        carroFim: '',
        motoInicio: '',
        motoFim: '',
        gratuidadeTeorica: false,
        gratuidadeCarro: false,
        gratuidadeMoto: false,
      },
      loading: false,
    }
  },
  methods: {
    async open(autoescola) {
      this.autoescola = autoescola

      await utils.sleep(100)

      this.$refs.modal.open()
    },
    close() {
      this.seller = ''
      this.inicioAtendimento = ''
      this.autoescola = null
      this.gratuidade = {
        teoricaInicio: '',
        teoricaFim: '',
        carroInicio: '',
        carroFim: '',
        motoInicio: '',
        motoFim: '',
        gratuidadeTeorica: false,
        gratuidadeCarro: false,
        gratuidadeMoto: false,
      }
    },
    async handleSubmitVendedor() {
      if (!this.inicioAtendimento && !this.seller) {
        this.$toasted.show('Obrigatório informar data e vendedor a ser atribuído!', {
          position: 'top-right',
        })

        return
      }

      this.loading = true

      const data = {
        autoescola: this.autoescola.id_cfc,
        data: this.inicioAtendimento,
        vendedor: this.seller,
      }

      await this.$http.post(`${process.env.VUE_APP_URL_API_V2}/vendedores/update/autoescola`, data)
        .then(res => {
          this.close()

          this.$emit('update')
        })
        .catch((err) => {
          this.$toasted.show(err.body.mensagem, {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    disabledTheoreticalGratuity() {
      this.gratuidade.teoricaInicio = ''
      this.gratuidade.teoricaFim = ''
    },
    disabledCarGratuity() {
      this.gratuidade.carroInicio = ''
      this.gratuidade.carroFim = ''
    },
    disabledMotocycleGratuity() {
      this.gratuidade.motoInicio = ''
      this.gratuidade.motoFim = ''
    },
    async handleUpdateGratuidade() {
      if ((!this.gratuidade.teoricaInicio && this.gratuidade.teoricaFim) || (this.gratuidade.teoricaInicio && !this.gratuidade.teoricaFim)) {
        this.gratuidade.teoricaInicio = ''
        this.gratuidade.teoricaFim = ''
      }

      if ((!this.gratuidade.carroInicio && this.gratuidade.carroFim) || (this.gratuidade.carroInicio && !this.gratuidade.carroFim)) {
        this.gratuidade.carroInicio = ''
        this.gratuidade.carroFim = ''
      }

      if ((!this.gratuidade.motoInicio && this.gratuidade.motoFim) || (this.gratuidade.motoInicio && !this.gratuidade.motoFim)) {
        this.gratuidade.motoInicio = ''
        this.gratuidade.motoFim = ''
      }

      this.loading = true

      await this.$http.patch(`${process.env.VUE_APP_URL_API_V2}/autoescola/atualizar/gratuidade/${this.autoescola.id_cfc}`, this.gratuidade)
        .then(res => {
          this.$toasted.show(res.body.mensagem, {
            position: 'top-right',
          })

          this.close()

          this.$emit('update:gratuidade')
        })
        .catch(err => {
          this.$toasted.show(err.body.mensagem, {
            position: 'top-right',
          })
        })
    },
  }
}
</script>

<style lang="scss" scoped>
.modal-container {
  width: 60vw;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .bloco:not(:last-child) {
    padding-bottom: 1rem;
    margin-bottom: 2rem;
    border-bottom: 1px solid #e0e0e0;
  }

  .input-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .full-button {
      justify-content: center;
    }
  }

  .input-row {
    display: flex;
    align-items: flex-end;
    gap: 1rem;

    .input-full {
      flex: 1;
    }

    .checkbox {
      label {
        margin: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.75rem;
        font-size: 0.875rem;
        font-weight: 600;
        line-height: 19.1px;
        color: #606264;
        cursor: pointer;

        input[type="checkbox"] {
          display: none;
        }

        span.input {
          position: relative;
          display: inline-block;
          width: 1rem;
          height: 1rem;
          border: 2px solid #DFDCDC;
          border-radius: 2px;
          background-color: #FAFAFA;
          transition: background-color 0.2s, border-color 0.2s;
        }

        input[type="checkbox"]:checked+span {
          background-color: #1C2D5A;
        }

        input[type="checkbox"]:checked+span::after {
          content: '✓';
          color: white;
          font-size: 8px;
          position: absolute;
          top: 55%;
          left: 50%;
          transform: translate(-50%, -50%);
        }

        span.text {
          max-width: 10rem;
        }
      }
    }
  }
}
</style>